<template>
  <div class="product-pager">
    <b-container>
      <b-row>
        <b-col cols="2">
          <b-form-select :value="state.limit" @change="changeLimit">
            <option :value="10">10件</option>
            <option :value="20">20件</option>
            <option :value="50">50件</option>
          </b-form-select>
        </b-col>
        <b-col>
          <b-pagination-nav
            :link-gen="linkGen"
            :value="state.page"
            :number-of-pages="state.pages"
            use-router
            align="center"
            @change="changePage"
          />
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'ProductPager',

  computed: {
    ...mapState({ state: 'products' }),
  },

  methods: {
    ...mapActions('products', ['searchList']),

    linkGen(page) {
      return '?';
    },

    changeLimit(limit) {
      this.searchList({
        limit: limit,
        page: 1,
        sortBy: this.state.sortBy,
        sortDesc: this.state.sortDesc,
        conditions: this.state.conditions,
      });
    },

    changePage(page) {
      this.searchList({
        limit: this.state.limit,
        page: page,
        sortBy: this.state.sortBy,
        sortDesc: this.state.sortDesc,
        conditions: this.state.conditions,
      });
    },
  },
};
</script>

<style scoped>
</style>
